import { tailwindMerge } from '../../../../tailwind';

export type TextSize = 's' | 'm' | 'l';

export interface TextProps
  extends Omit<React.ComponentPropsWithRef<'p'>, 'color'> {
  size?: TextSize;
  asSpan?: boolean;
}
/**
 * @deprecated Use tailwind classes instead
 */
export const Text = ({ className, asSpan, size, ...props }: TextProps) => {
  const commonClassName = 'text-text m-zero font-normal';

  if (asSpan) {
    return (
      <span
        className={tailwindMerge(
          commonClassName,
          getTextClass(size),
          className,
        )}
        {...props}
      />
    );
  }
  return (
    <p
      className={tailwindMerge(commonClassName, getTextClass(size), className)}
      {...props}
    />
  );
};

export const getTextClass = (size: TextSize = 'm') => {
  switch (size) {
    case 's':
      return 'text-s max-w-line-s';
    case 'm':
      return 'text-m max-w-line-m';
    case 'l':
      return 'text-l max-w-line-l';
  }
};
